import Filter from './Filter'

export default class Letter extends Filter {
    filterComponent = import('@/views/components/filters/compoents/LetterFilterComponent.vue')

    static LETTER_TYPE = 'letter_type'

    static LETTER_STATUS = 'letter_status'

    static PERIOD = 'period'

    static TO_ORG = 'to_org'

    fields = {
      [Letter.LETTER_TYPE]: {
        label: 'Letter Type',
      },
      [Letter.LETTER_STATUS]: {
        label: 'Letter Status',
      },
      [Letter.PERIOD]: {
        label: 'Period',
      },
      [Letter.TO_ORG]: {
        label: 'To Org',
      },
    }
}
